export const DEFAULT_PAGE_SIZE = {
  vehicleSizeChart: 100,
  pricingException: 100,
  quote: 100,
  followup: 100,
  invite: 100,
  user: 20,
  carrier: 50
};
